export default __webpack_public_path__ + "./fonts/phone.7d2814d8.svg";